import ProfileImg from '@core/components/ProfileImg';
import { RoutePath } from '@core/types/route';
import { H2Gold } from '@homepage/components/ColoredHeading';
import { SectionDark1 } from '@homepage/components/ColoredSection';
import RouteButton from '@homepage/components/RouteButton';
import { COLOR } from '@homepage/types/theme';
import Grid2 from '@shared/components/Grid2';
import { H2 } from '@shared/components/Heading';
import List from '@shared/components/List';
import ListItem from '@shared/components/ListItem';
import Paragraph from '@shared/components/Paragraph';
import Section from '@shared/components/Section';
import { FC, memo } from 'react';

import { COMPANY } from '../../assets/company';

const C2A: FC = () => (
  <>
    <SectionDark1>
      <H2Gold center>Überzeuge Dich selbst - komm zum Probetraining</H2Gold>
      <Grid2 spacing='2rem'>
        <Grid2.Centered>
          <ProfileImg alt={COMPANY.contact.img.alt} src={COMPANY.contact.img.src} />
        </Grid2.Centered>
        <Grid2.Item>
          <Paragraph margin={{ bottom: '2rem' }}>
            Ein Probetraining ist jederzeit während unserer regulären Unterrichtseinheiten möglich.
            Melde Dich einfach an, um Dein Probetraining zu vereinbaren. {COMPANY.contact.text},
            nimmt Deine Anmeldung gern entgegen. Starte jetzt und entdecke Systema – wir freuen uns
            auf Dich!
          </Paragraph>

          <RouteButton background={COLOR.White} bold color={COLOR.Gold2} href={RoutePath.Kontakt}>
            Melde Dich jetzt an!
          </RouteButton>
        </Grid2.Item>
      </Grid2>
    </SectionDark1>

    <Section>
      <H2>Hinweise für Dein Training</H2>
      <List bullets margin={{ left: { md: '6rem' } }}>
        <ListItem>Jedes Probetraining kostet {COMPANY.trialFee}€.</ListItem>
        <ListItem>Bring bitte bequeme Sportsachen mit.</ListItem>
        <ListItem>Das Training findet mit Socken oder barfuss statt.</ListItem>
      </List>
    </Section>
  </>
);

export default memo(C2A);
